import { Col, Row, Typography } from "antd";
import { Formik } from "formik";
import * as Yup from "yup";

import { Form } from "formik-antd";
import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { FormikPassword, FormikSubmitButton } from "../FormItems";
import Feedback from "../Utilities/Feedback";
import { CheckOutlined } from "@ant-design/icons";
import { changePassword } from "../Redux/User/reducer";
import constants from "../Redux/constants";
import { useHistory } from "react-router-dom";

const initialValues = {
  newPassword: "",
  confirmPassword: "",
};

const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8)
    .required("Password is required")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("newPassword"), null],
    "Passwords should match"
  ),
});

const ChangePasswordForm = (props) => {
  const history = useHistory();
  const { userRole } = useSelector((state) => state.userStore);
  const { passwordChange } = props;
  const [isUpdated, setIsUpdated] = useState(false);
  const changePassword = async (values) => {
    const { responseStatus } = await passwordChange(values);
    if (responseStatus === constants.status.success) {
      setIsUpdated(true);
      setTimeout(() => {
        userRole === constants.roles.client
          ? history.push("/client/home")
          : history.push("/consultant/home");
      }, 2021);
    }
  };
  return (
    <Col
      xs={{ span: 24 }}
      style={{
        background: "#ffffff",
        padding: "4vh",
      }}
    >
      <Row>
        <Col xl={{ span: 10 }} style={{ margin: "auto" }}>
          {isUpdated ? (
            <Feedback
              status="success"
              icon={<CheckOutlined />}
              title="Password Updated Succesfully"
              subTitle="Redirecting to homepage"
            ></Feedback>
          ) : (
            <Col>
              <Row>
                <Typography.Title level={4}>Change Password</Typography.Title>
              </Row>
              <Col style={{ marginTop: "2vh" }}>
                <Formik
                  initialValues={initialValues}
                  validateOnMount
                  validationSchema={validationSchema}
                  onSubmit={changePassword}
                >
                  {(formik) => {
                    return (
                      <Form>
                        <FormikPassword
                          name="newPassword"
                          label="New Password"
                          icon={true}
                          suffix={true}
                        ></FormikPassword>
                        <FormikPassword
                          name="confirmPassword"
                          label="Confirm Password"
                        ></FormikPassword>
                        <FormikSubmitButton
                          name="Update Password"
                          disabled={!formik.isValid}
                        />
                      </Form>
                    );
                  }}
                </Formik>
              </Col>
            </Col>
          )}
        </Col>
      </Row>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    passwordChange: (data) => dispatch(changePassword(data)),
  };
};

export default connect(null, mapDispatchToProps)(ChangePasswordForm);
